import React, { Component } from 'react';
import { Alert } from 'antd';
import { pathOr } from 'ramda';

const ERRORS = {
    'USER_NOT_FOUND': 'К сожалению, данный e-mail не зарегистрирован на сайте.',
};

export default class FormWrapper extends Component {
    render() {
        const { error } = this.props;

        const errorCode = pathOr('Ошибка', ['data', 'error'], error);
        const errorMessage = error ? ERRORS[errorCode] || (
            `${pathOr('Ошибка', ['data', 'error_message_ru'], error)}`
        ) : '';

        return error ? (
            <Alert message={errorMessage} type="error" />
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/common/fields/ServerError.js